module.exports = __webpack_public_path__ + "img/mission-diversity-office.jpg?4507754e70decfdf417e827e2d72e438";